import { useEffect, useRef } from "react";

/**
 * 
 * @returns refrence value
 * 
 * should be use like 
 *  const isUnmounted = useIsUnmounted();
 *
 *   if(isUnmounted.current) // condition
 */

export function useIsUnmounted(){
    const tempRef = useRef(false);
    useEffect(() => {
      return () => {
        tempRef.current = true;
      }
    }, []);

    return tempRef;
}
